import { useSelector } from 'react-redux';
import { ErrorMarkup } from 'modules/error';
import { selectFeatureFlags } from 'core/userContext';
import { selectEnabledPreviews } from 'modules/app/selectors';
import { CUSTOM_SEND_CONTROL_PUSH_UI } from 'modules/sendingPlatforms/previewKeys';
import { CustomPushDestinationsSection } from './CustomPushDestinationsSection';
import { CustomPushAccountsHeader } from './CustomPushAccountsHeader';
import { CustomPushModals } from './CustomPushModals';
import { Sidebar } from '../Sidebar';
import { Wrapper, MainContent } from '../Page.styled';
import { PageHeader } from '../PageHeader';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { CUSTOM_PUSH } from '../../../constants';

export const CustomPushPage = () => {
  const { hasError } = useSendingPlatformsQueryContext();
  const { CustomSendControlPushUI = false } = useSelector(selectFeatureFlags);
  const isCustomSendControlPushUIEnabled = useSelector(selectEnabledPreviews).includes(
    CUSTOM_SEND_CONTROL_PUSH_UI,
  );

  if (!CustomSendControlPushUI && !isCustomSendControlPushUIEnabled) return null;

  if (hasError) {
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );
  }

  return (
    <div>
      <PageHeader sendingPlatform={CUSTOM_PUSH} />
      <Wrapper>
        <Sidebar sendingPlatform={CUSTOM_PUSH} />
        <MainContent>
          <CustomPushAccountsHeader />
          <CustomPushDestinationsSection />
        </MainContent>
      </Wrapper>
      <CustomPushModals />
    </div>
  );
};
